
import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Hero from './components/Hero';
import FeaturedModels from './components/FeaturedModels';
import ProcessShowcase from './components/ProcessShowcase';
import Stats from './components/Stats';
import CTA from './components/CTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <Stats />
      <FeaturedModels />
      <ProcessShowcase />
      <CTA />
    </div>
  );
}
